<label
  [attr.for]="_id"
  class="go-form__label"
  [ngClass]="{ 'go-form__label--dark': theme == 'dark' }"
>
  {{ label }}
  <go-required-text [control]="control"></go-required-text>
</label>
<div class="go-timepicker">
  <input
    #datepickerInput
    class="go-form__input go-input-time"
    [id]="_id"
    [placeholder]="placeholder"
    [ngClass]="inputClasses"
    [(ngModel)]="selectedTime"
    [disabled]="control.disabled"
    (click)="toggleTimepicker($event)"
    readonly
  />
  <go-icon-button
    class="go-timepicker__toggle"
    [buttonDisabled]="control.disabled"
    buttonIcon="schedule"
    (click)="toggleTimepicker($event)"
  ></go-icon-button>
  <go-time
    *ngIf="timeOpen"
    [appendToContent]="appendToContent"
    [displayFromRight]="displayFromRight"
    [displayAbove]="displayAbove"
    [selectedTime]="openTimeValue"
    (timePicked)="timePicked($event)"
    (closeTime)="closeTime()"
    [theme]="theme"
  >
  </go-time>
</div>
<go-hint *ngFor="let hint of hints" [message]="hint" [theme]="theme"></go-hint>
<div *ngIf="!hideFieldError">
  <go-form-errors [control]="control" [theme]="theme"></go-form-errors>
</div>
